namespace App {
	export let renderer: PIXI.WebGLRenderer = null;
	export let canvas: HTMLCanvasElement = null;
	export let stage: PIXI.display.Stage = null;

	export let screen: PIXI.Rectangle;

	export function init() {
		PIXI.settings.GC_MODE = PIXI.GC_MODES.MANUAL;

		canvas = document.getElementById("ourCanvas") as HTMLCanvasElement;

		renderer = new PIXI.WebGLRenderer(1334, 750, {
			backgroundColor: 0x586d16,
			transparent: false,
			antialias: false,
			view: canvas
		});

		let ratio = window.devicePixelRatio;
		if (ratio == 2) {
			let w = renderer.width / ratio;
			let h = renderer.height / ratio;
			canvas.style.width = w + 'px';
			canvas.style.height = h + 'px';
		}

		const gl = renderer.gl;

		createStage();

		// PandaConsole.logInfo((new WebGLDescriber(gl)).toString());

		MainLoop.onEnterFrame.addListener(handler_enterFrame);

		PIXI.ticker.shared.stop();

		screen = renderer.screen;

		Assets.preload(() => {
			Game.start();
			Tutorial.start();
		})


	}

	export function createStage() {
		stage = new PIXI.display.Stage();
		stage.hitArea = renderer.screen;
	}

	function handler_enterFrame(millisecondsDelta: number, millisecondsAbsolute: number): void {
		// updates pixi interaction
		renderer.plugins['interaction'].update();

		renderer.render(stage);
	}
}